import moment from 'moment';

// Received-date ranges are sent as ISO-8601 UTC instants bounding the user's
// local day, so the backend filters in the user's timezone instead of the UTC
// day. Bare YYYY-MM-DD values (older bookmarked URLs, due/appointment ranges)
// keep their calendar-date semantics. The detector mirrors the backend's
// Validatable.parse_filter_instant.
const INSTANT_PATTERN = /T\d{2}:\d{2}/;

export const toLocalDayStartInstant = (date) => (
  date ? date.clone().startOf('day').toISOString() : null
);

export const toLocalDayEndInstant = (date) => (
  date ? date.clone().endOf('day').toISOString() : null
);

export const parseDateFilterParam = (value) => {
  const parsed = INSTANT_PATTERN.test(value)
    ? moment(value, moment.ISO_8601, true)
    : moment(value, 'YYYY-MM-DD', true);
  return parsed.isValid() ? parsed : null;
};
